// The organisation header, at the call site.
//
// Every organisation-scoped operation requires X-Org-ID, and the generated
// types say so — a call that omits it does not compile. That is the arrangement
// this file supports rather than works around: the tenant a request acts in is
// visible where the request is made, not hidden in an interceptor.

import { useSession } from '../lib/session';

/** The header every org-scoped call passes. */
export type OrgHeader = { 'X-Org-ID': string };

/**
 * The current organisation as a header.
 *
 * Throws when none is chosen, which cannot happen from a rendered page: the
 * shell does not route anywhere org-scoped until one is. The throw is there so
 * that if it ever does, it fails here rather than as a 400 from the server.
 */
export function useOrg(): OrgHeader {
  const { orgId } = useSession();
  if (!orgId) throw new Error('no organisation is chosen');
  return { 'X-Org-ID': orgId };
}
